import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Modal, Form, Table } from 'react-bootstrap';
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import User from "../../../assets/images/useer_view.png";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETTYPECODE, GETOWNERCODE, MSGSETTINGLIST, SAVEMSGRULE, SWITCHMSGRULE, DELETERULE } from '../../../Utils/conts.js';

const MessageSettings = () => {
    const isMounted = useRef(false);
    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isDelete, setIsDelete] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [rulesList, setRulesList] = useState({ Rows: [], activity_status: '' });
    const msgType = [
        { label: 'UCM', value: 'UCM' },
        { label: 'FFM', value: 'FFM' },
        { label: 'CPM', value: 'CPM' },
        { label: 'LUC', value: 'LUC' },
        { label: 'SCM', value: 'SCM' },
    ];
    const filterBy = [
        { label: 'Flight Prefix', value: 'prefix' },
        { label: 'ULD Type Code', value: 'type_code' },
        { label: 'ULD Owner Code', value: 'owner_code' },
    ];

    const fetchRuleList = async () => {
        try {
            const res = await withRFSToken.post(MSGSETTINGLIST, { setting_type: 'message' });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                console.log(innerData);
                const transformedData = {
                    ...innerData,
                    activity_status: innerData.activity_status === 1 ? true : false
                };
                setRulesList(transformedData);
            } else {
                toast.error(res.data.response_msg);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchTypeCode = async () => {
        try {

            const res = await withRFSToken.post(GETTYPECODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.uld_typecode,
                        label: item.uld_typecode
                    })) : [];
                    setGetTypeCodes(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchRuleList();
        fetchTypeCode();
        fetchOwnerCode();
        isMounted.current = true;
    }, []);

    const handleCheckboxChange = async (event) => {
        // console.log("🚀 ~ handleCheckboxChange ~ event:", event)
        // setIsVisible(event.target.checked);
        if (event.target.checked === false) {
            setShowConfirmation(true);
        } else {
            try {
                const res = await withRFSToken.post(SWITCHMSGRULE, { setting_type: 'message', activity_status: 1 });
                // .then(function (res) {
                if (res.data.response_code === 200) {
                    toast.success('Rules activity status updated')
                    fetchRuleList();
                } else {
                    toast.error(res.data.response_msg);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };
    const gridRef = useRef(null);
    const [rules, setRules] = useState([
        { id: 1, rule_id: '', rule_name: '', message_type: '', filter_by: '', filter_criteria: '' },
    ]);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState('');
    const modalShow = (pos, data) => {
        setShowModal(true);
        setIsEdit(pos);
        if (pos == 'add') {
            setRules({ id: 1, rule_id: '', rule_name: '', message_type: '', filter_by: '', filter_criteria: [] })
        } else {
            let convertedData;
            if (data.filter_criteria == 'All') {
                if (data.filter_by == 'type_code') {
                    const selectedIds = getTypeCodes.map(item => item.value);
                    convertedData = {
                        ...data,
                        filter_criteria: selectedIds, // Split by comma
                    };
                } else {
                    const selectedIds = getOwnerCodes.map(item => item.value);
                    convertedData = {
                        ...data,
                        filter_criteria: selectedIds, // Split by comma
                    };
                }
            } else {
                convertedData = {
                    ...data,
                    filter_criteria: data.filter_criteria.split(','), // Split by comma
                };
            }
            // const convertedData = {
            //     ...data,
            //     filter_criteria: data.filter_criteria.split(','), // Split by comma
            // };
            setRules(convertedData);
            if (data.filter_by === 'type_code') {
                setSelectedOption(getTypeCodes)
            } else {
                setSelectedOption(getOwnerCodes)
            }
        }
    }
    const modalClose = () => {
        setShowModal(false);
        setIsDelete('');
    }
    const deleteRule = (id) => {
        setShowConfirmation(true);
        setIsDelete(id);
    };

    const handleConfirm = async () => {
        if (isDelete !== '') {
            try {
                const res = await withRFSToken.post(DELETERULE, { rule_id: isDelete });
                // .then(function (res) {
                if (res.data.response_code === 200) {
                    setShowConfirmation(false);
                    fetchRuleList();
                    toast.success('Rules removed successfully')
                    setIsDelete('');
                } else {
                    toast.error(res.data.response_msg);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            try {
                const res = await withRFSToken.post(SWITCHMSGRULE, { setting_type: 'message', activity_status: 0 });
                // .then(function (res) {
                if (res.data.response_code === 200) {
                    setShowConfirmation(false);
                    fetchRuleList();
                    toast.success('Rules activity status updated')
                } else {
                    toast.error(res.data.response_msg);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

    }

    const handleInputChange = (event) => {
        // const updatedRules = rules.map((rule) =>
        //     rule.id === id ? { ...rule, [field]: e.target.value } : rule
        // );
        // setRules(updatedRules);
        const { name, value } = event.target;
        setRules(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const dataCheck = () => {
        if (rules.filter_by == 'type_code') {
            if (rules.filter_criteria.length === getTypeCodes.length) {
                return { ...rules, filter_criteria: ['All'] }
            } else { return rules }
        } else {
            if (rules.filter_criteria.length === getOwnerCodes.length) {
                return { ...rules, filter_criteria: ['All'] }
            }
            else { return rules }
        }
    }
    const saveRule = async () => {

        const sendData = {
            setting_type: 'message',
            rule: dataCheck(rules)
        }
        try {
            const res = await withRFSToken.post(SAVEMSGRULE, { setting_type: 'message', rule_id: isEdit ? rules.rule_id : '', rule: dataCheck(rules) });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                toast.success('Rules Added Successfully');
                setShowModal(false);
                const innerData = res.data.response_data;
                fetchRuleList()
            } else {
                toast.error(res.data.response_msg);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
         {/* <div className=""> */}
            {/* {console.log('rulesList', rules)} */}
            {/* {console.log('getTypeCodes', getTypeCodes)} */}
            {/* <Header page_type='' logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'}  />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <h4>Message Settings</h4>
                                <p>Customize and Manage Your Message Filters</p>
                                <div className='w-55'>
                                    <div className='d-flex justify-content-between align-items-center mb-3'>
                                        <div className='setting_switch'>
                                            <h3>Message Filter</h3>
                                            <p>Allow floating notification</p>
                                        </div>
                                        {/* <div className='raswitch'>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="flexSwitchCheckDefault"
                                                    name='activity_status'
                                                    onChange={handleCheckboxChange}
                                                    checked={rulesList.activity_status} // Ensure checkbox reflects the state
                                                />
                                            </div>
                                        </div> */}
                                        <div className=''>
                                            <Button variant="primary" className='stk_add' onClick={() => modalShow('add')}>
                                                <FontAwesomeIcon icon={faPlus} />Add Rule
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                <div className="stck_middle mt-2 w-55">
                                    {rulesList?.Rows.length > 0 && (
                                        <div className='uld_notification'>

                                            <Table className=''>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Rule Name</th>
                                                        <th>Message Type</th>
                                                        <th>Filter By</th>
                                                        <th>Filter Criteria</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rulesList?.Rows.map((rule, index) => {
                                                        const filterByLabel = filterBy.find((filter) => filter.value === rule.filter_by)?.label || rule.filter_by;

                                                        return (
                                                            <>
                                                                <tr key={rule.rule_id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <span className='rule_box'>{rule?.rule_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className='rule_box'>{rule?.message_type}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className='rule_box'>{filterByLabel}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className='rule_box'>{rule?.filter_criteria}</span>
                                                                    </td>


                                                                    <td style={{ display: 'flex' }}>

                                                                        <div className='imag_trash'>
                                                                            <img src={Edit} alt='Edit' onClick={() => modalShow('edit', rule)} />
                                                                        </div>

                                                                        {/* {rulesList?.Rows.length > 1 && ( */}
                                                                        <div className='imag_trash'>
                                                                            <img src={Trash} alt='Delete' onClick={() => deleteRule(rule.rule_id)} />
                                                                        </div>
                                                                        {/* )} */}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                     {/* </div>
                 </div>
             </div> */}
            <Modal show={showModal} onHide={modalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={modalClose}>
                    <Modal.Title>{isEdit === 'edit' ? 'Edit' : 'Add'} Rule</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Rule Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={rules.rule_name}
                            name='rule_name'
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Message Type</Form.Label>
                        <Select
                            options={msgType}
                            onChange={(selected) => {
                                const updatedData = { ...rules, message_type: selected.value };
                                setRules(updatedData);
                            }}
                            placeholder="Select"
                            className='down_selct'
                            name="message_type"
                            value={msgType.find(option => option.value === rules.message_type)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Filter By</Form.Label>
                        <Select
                            options={filterBy}
                            onChange={(selected) => {
                                const updatedData = { ...rules, filter_by: selected.value };
                                setRules(updatedData);
                                if (selected.value === 'type_code') {
                                    setSelectedOption(getTypeCodes)
                                } else {
                                    setSelectedOption(getOwnerCodes)
                                }
                            }}
                            placeholder="Select"
                            className='down_selct'
                            name="filter_by"
                            value={filterBy.find(option => option.value === rules.filter_by)}
                        // onKeyDown={handleKeyPress}
                        />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Filter Criteria</Form.Label>
                        <MultiSelect
                            // options={selectedOption}
                            // value={selectedOption.filter(option => rule.filtercriteria?.includes(option.value)) || []}
                            options={selectedOption}
                            value={selectedOption?.filter((item) => rules.filter_criteria?.includes(item.value)) || []}
                            onChange={(selected) => {
                                const selectedIds = selected.map(item => item.value);
                                setRules((prevFormData) => ({
                                    ...prevFormData,
                                    filter_criteria: selectedIds
                                }));
                            }}
                            labelledBy="Select "
                            className='multiselect'
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={saveRule}  >
                        {isEdit === 'edit' ? 'Update' : 'Add'} Rule
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{isDelete !== '' ? 'Delete Message Rule' : 'Message Rule De-Activation'}</h3>
                    <p>Are you sure you want to {isDelete !== '' ? 'Delete' : 'De-Activate'} ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={handleConfirm}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        {/* </div> */}
        </>
    );
}

export default MessageSettings